export const retryTips = "Server connection failed, would you like to try again?";
